import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMProject } from "../graphql/mutations";
import { UpdateLLMProjectMutation } from "../API";

export interface UpdateOpenRouterGroupsInput {
  id: string;
  openrouterStandardGroupModels: string;
  openrouterPremiumGroupModels: string;
}

export async function updateProjectOpenRouterGroups(
  values: UpdateOpenRouterGroupsInput
): Promise<GraphQLResult<UpdateLLMProjectMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMProject, {
      input: {
        id: values.id,
        openrouterStandardGroupModels: values.openrouterStandardGroupModels,
        openrouterPremiumGroupModels: values.openrouterPremiumGroupModels,
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMProjectMutation>>;
}
